import proj4 from 'proj4';
import { PickAnAttribute } from './PickAnAttribute';

export function CalcLeftRight(nodeId, nodes, connections) {
  var left_right_json = {};
  var conn_map = [];
  var vantage_point = [-77.023162, 40.10521];
  try {
    var v_points = nodes[nodeId]['attributes']['vantage_point'];
    var v_point = v_points[Object.keys(v_points)[0]];
    vantage_point = [v_point['longitude'] ?? vantage_point[0], v_point['latitude'] ?? vantage_point[1]];
  } catch (err) {}
  var photo_target = nodes[nodeId];
  var photo_heading = CalcHeadingFromLatLong(vantage_point[1], vantage_point[0], photo_target['latitude'], photo_target['longitude']);
  var optimal_left = photo_heading - 90;
  var optimal_right = photo_heading + 90;
  for (var connId in connections) {
    var conn_type = PickAnAttribute(connections[connId].attributes, 'connection_type');
    var node_id_1 = connections[connId].node_id_1;
    var node_id_2 = connections[connId].node_id_2;
    var connection_details = {};
    if (conn_type != 'down guy' && conn_type != 'pushbrace' && (nodeId == node_id_1 || nodeId == node_id_2)) {
      connection_details['connection_type'] = conn_type;
      if (nodeId == node_id_1) {
        connection_details['connected_node'] = node_id_2;
      } else if (nodeId == node_id_2) {
        connection_details['connected_node'] = node_id_1;
      }
      var origin = nodes[nodeId];
      var target = nodes[connection_details['connected_node']];
      if (origin != null && target != null) {
        connection_details['heading'] = CalcHeadingFromLatLong(
          origin['latitude'],
          origin['longitude'],
          target['latitude'],
          target['longitude']
        );
        var dev_left = Math.abs(connection_details['heading'] - optimal_left);
        if (dev_left > 180) {
          dev_left = 360 - dev_left;
        }
        var dev_right = Math.abs(connection_details['heading'] - optimal_right);
        if (dev_right > 180) {
          dev_right = 360 - dev_right;
        }
        connection_details['photo_heading'] = photo_heading;
        connection_details['deviation_left'] = dev_left;
        connection_details['deviation_right'] = dev_right;
        connection_details['connection_id'] = connId;
        conn_map.push(connection_details);
      }
    }
  }
  var best_match = {};
  var best_other_match = {};
  var best = 360;
  var found_best_aerial_match = false;
  var found_best_ref_match = false;
  var found_next_best_aerial_match = false;
  var found_next_best_ref_match = false;
  ///////////////// START OF BLUNT INSTRAMENT (I CAN DO BETTER)
  //best non reference
  for (var i = 0; i < conn_map.length; i++) {
    if (conn_map[i]['deviation_left'] < best && conn_map[i]['connection_type'] != 'reference') {
      best = conn_map[i]['deviation_left'];
      best_match['direction'] = 'left';
      best_match['node_id'] = conn_map[i]['connected_node'];
      best_match['connection_id'] = conn_map[i]['connection_id'];
      found_best_aerial_match = true;
    }
    if (conn_map[i]['deviation_right'] < best && conn_map[i]['connection_type'] != 'reference') {
      best = conn_map[i]['deviation_right'];
      best_match['direction'] = 'right';
      best_match['node_id'] = conn_map[i]['connected_node'];
      best_match['connection_id'] = conn_map[i]['connection_id'];
      found_best_aerial_match = true;
    }
  }
  //find best ref
  if (!found_best_aerial_match) {
    best = 360;
    for (var i = 0; i < conn_map.length; i++) {
      if (conn_map[i]['connection_type'] == 'reference') {
        if (conn_map[i]['deviation_left'] < best) {
          best = conn_map[i]['deviation_left'];
          best_match['direction'] = 'left';
          best_match['node_id'] = conn_map[i]['connected_node'];
          best_match['connection_id'] = conn_map[i]['connection_id'];
          found_best_ref_match = true;
        }
        if (conn_map[i]['deviation_right'] < best) {
          best = conn_map[i]['deviation_right'];
          best_match['direction'] = 'right';
          best_match['node_id'] = conn_map[i]['connected_node'];
          best_match['connection_id'] = conn_map[i]['connection_id'];
          found_best_ref_match = true;
        }
      }
    }
  }
  //best other non reference
  if (found_best_aerial_match) {
    best = 360;
    for (var i = 0; i < conn_map.length; i++) {
      if (conn_map[i]['connection_type'] != 'reference' && best_match['node_id'] != conn_map[i]['connected_node']) {
        if (conn_map[i]['deviation_left'] < best && best_match['direction'] != 'left') {
          best = conn_map[i]['deviation_left'];
          best_other_match['direction'] = 'left';
          best_other_match['node_id'] = conn_map[i]['connected_node'];
          best_other_match['connection_id'] = conn_map[i]['connection_id'];
          found_next_best_aerial_match = true;
        }
        if (conn_map[i]['deviation_right'] < best && best_match['direction'] != 'right') {
          best = conn_map[i]['deviation_right'];
          best_other_match['direction'] = 'right';
          best_other_match['node_id'] = conn_map[i]['connected_node'];
          best_other_match['connection_id'] = conn_map[i]['connection_id'];
          found_next_best_aerial_match = true;
        }
      }
    }
  }
  //best other ref
  if ((found_best_aerial_match || found_best_ref_match) && !found_next_best_aerial_match) {
    best = 360;
    for (var i = 0; i < conn_map.length; i++) {
      if (conn_map[i]['connection_type'] == 'reference' && best_match['node_id'] != conn_map[i]['connected_node']) {
        if (conn_map[i]['deviation_left'] < best && best_match['direction'] != 'left') {
          best = conn_map[i]['deviation_left'];
          best_other_match['direction'] = 'left';
          best_other_match['node_id'] = conn_map[i]['connected_node'];
          best_other_match['connection_id'] = conn_map[i]['connection_id'];
          found_next_best_ref_match = true;
        }
        if (conn_map[i]['deviation_right'] < best && best_match['direction'] != 'right') {
          best = conn_map[i]['deviation_right'];
          best_other_match['direction'] = 'right';
          best_other_match['node_id'] = conn_map[i]['connected_node'];
          best_other_match['connection_id'] = conn_map[i]['connection_id'];
          found_next_best_ref_match = true;
        }
      }
    }
  }
  ///////////////// END OF BLUNT INSTRAMENT
  left_right_json['node_id'] = nodeId;
  if (found_best_aerial_match || found_best_ref_match) {
    left_right_json['node_' + best_match['direction']] = best_match['node_id'];
    left_right_json['connection_' + best_match['direction']] = best_match['connection_id'];
  }
  if (found_next_best_aerial_match || found_next_best_ref_match) {
    left_right_json['node_' + best_other_match['direction']] = best_other_match['node_id'];
    left_right_json['connection_' + best_other_match['direction']] = best_other_match['connection_id'];
  }
  return left_right_json;
}

function CalcHeadingFromLatLong(origin_lat, origin_long, target_lat, target_long) {
  var toProjection = '+proj=utm +zone=18 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs';
  var origin = proj4(toProjection, [origin_long, origin_lat]);
  var target = proj4(toProjection, [target_long, target_lat]);
  var x0 = origin[0];
  var y0 = origin[1];
  var x1 = target[0];
  var y1 = target[1];
  var heading = Math.atan2(x0 - x1, y0 - y1);
  heading = (heading * 180) / Math.PI;
  heading = heading + 180;
  return heading;
}
